import { render, staticRenderFns } from "./RecentScreencasts.vue?vue&type=template&id=15adad7a"
import script from "./RecentScreencasts.vue?vue&type=script&lang=js"
export * from "./RecentScreencasts.vue?vue&type=script&lang=js"
import style0 from "./RecentScreencasts.vue?vue&type=style&index=0&id=15adad7a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports